import { TaskName } from '@/common/constants/taskNames.constants';
import { MultipathConfig, TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.EXTERNAL_STORAGE_CREATE]: {
    [TaskState.SUCCESS]: ({ payload }) => ({
      title: i18n.t('External storage added'),
      message: payload.name,
    }),
    [TaskState.RUNNING]: ({ payload }) => ({
      title: i18n.t('Adding external storage...'),
      message: payload.name,
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to add external storage'),
      message: error
    })
  },
  [TaskName.EXTERNAL_STORAGE_UPDATE]: {
    [TaskState.SUCCESS]: ({ payload }) => ({
      title: i18n.t('External storage changed'),
      message: payload.name,
    }),
    [TaskState.RUNNING]: ({ payload }) => ({
      title: i18n.t('Changing external storage...'),
      message: payload.name,
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to change external storage'),
      message: error
    })
  },
  [TaskName.RECONFIGURE_MULTIPATH]: {
    [TaskState.SUCCESS]: ({ payload }) => {
      if (!payload?.config_data) return undefined;

      const configData = payload.config_data as MultipathConfig;

      switch (configData.type) {
        case MultipathConfig.type.PREDEFINED:
          return {
            message: i18n.t('Multipath configuration enabled')
          };
        case MultipathConfig.type.CUSTOM:
          return {
            message: i18n.t('Custom multipath configuration applied')
          };
        case MultipathConfig.type.DEFAULT:
          return {
            message: i18n.t('Multipath configuration disabled')
          };
        default:
          return {
            message: i18n.t('Multipath configuration updated')
          };
      }
    },
    [TaskState.RUNNING]: ({ payload }) => {
      if (!payload?.config_data) return undefined;

      const configData = payload.config_data as MultipathConfig;

      switch (configData.type) {
        case MultipathConfig.type.PREDEFINED:
          return {
            message: i18n.t('Enabling multipath configuration...')
          };
        case MultipathConfig.type.CUSTOM:
          return {
            message: i18n.t('Applying custom multipath configuration...')
          };
        case MultipathConfig.type.DEFAULT:
          return {
            message: i18n.t('Disabling multipath configuration...')
          };
        default:
          return {
            message: i18n.t('Updating multipath configuration...')
          };
      }
    },
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to update multipath configuration'),
      message: error
    })
  }
};

export default taskMap;
